export const GRAPHQL_VARIABLES = {
  contentType: 'image/png'
};

export const QUERY = `
  query getBankStmtUploadUrl($contentType: String!){
    getBankStmtUploadUrl(contentType: $contentType) {
        url
    }
}
`;
